import { render, staticRenderFns } from "./PrepList.vue?vue&type=template&id=1151e25d&scoped=true"
import script from "./PrepList.vue?vue&type=script&lang=js"
export * from "./PrepList.vue?vue&type=script&lang=js"
import style0 from "./PrepList.vue?vue&type=style&index=0&id=1151e25d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1151e25d",
  null
  
)

export default component.exports